import React, {useState, useEffect, useRef, useContext} from "react";
import {Link} from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import * as ApiCalls from "../ApiCalls";
import {azureTokenContext, userIdContext} from "../../../App";

const OpenDocumentDropdown = ({row}) => {
    const azureToken = useContext(azureTokenContext);
    const userId = useContext(userIdContext);

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Handle clicks outside the dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const logOpenDocumentClick = () => {
        log("INFO", "Open word document", "AuthorsPortal", row.WorkItemId, row.Role);
        logMetric("Open word document", "AuthorsPortal", "", "", "Open word document", row.WorkItemId, row.Role);
    };

    const log = (level, message, method, workItemId, userRole) => {
        ApiCalls.log(level, message, method, workItemId, userRole, userId, azureToken);
    };

    const logMetric = (category, subCategory, status, tag, message, workItemId, userRole) => {
        ApiCalls.logMetric(category, subCategory, status, tag, message, workItemId, userRole, userId, azureToken);
    };

    return (
        <div className="openDocument-container relative inline-block text-left" ref={dropdownRef}>
            <div className="openDocument-button flex items-center">
                <Link
                    to={row.LinkToDocument ?? row.SharepointPath}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:text-blue-800 transition-colors text-nowrap"
                    aria-label="Åpne dokument i nettleser"
                    onClick={logOpenDocumentClick}
                >
                    Åpne i nettleser
                </Link>
                <button
                    onClick={toggleDropdown}
                    className="openDocument-DropdownButton rounded-full hover:bg-gray-100 transition-colors"
                    aria-label="Vis dokumentvalg"
                    aria-expanded={isOpen}
                >
                    <ArrowDropDownIcon className="text-gray-600"/>
                </button>
            </div>

            {isOpen && (
                <div
                    className="openDocument-secondLink absolute left-0 mt-0.5 w-60 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                    <Link
                        to={getOpenInWordUrl(row.LinkToDocument ?? row.SharepointPath, row.SharepointFolder)}
                        className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                            logOpenDocumentClick();
                            setIsOpen(false);
                        }}
                        aria-label="Åpne i skrivebordsprogram"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Åpne i skrivebordsprogram
                    </Link>
                </div>
            )}
        </div>
    );
};

export default OpenDocumentDropdown;

export function getOpenInWordUrl(linkToDocument, sharepointFolder, postFixFolder = "") {
    let fileName = linkToDocument?.split("&").find((itm) => itm.includes("file="));
    fileName = fileName ? fileName.replace("file=", "") : "";
    if (!postFixFolder || postFixFolder.trim() === "") {
        return `ms-word:ofe|u|${sharepointFolder ?? ""}/${fileName}`;
    } else {
        return `ms-word:ofe|u|${sharepointFolder ?? ""}/${postFixFolder}/${fileName}`;
    }
}
